import { readResumeForm, firstMissingResumeSlide } from '../utils/resumeForm';
import { getContactId, setContactId } from '../utils/contactId';
import * as Sentry from '@sentry/react';
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Navigation, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import Slide1 from "./Slide1";
import Slide2 from "./Slide2";
import Slide3 from "./Slide3";
import Slide4 from "./Slide4";
import Slide5 from "./Slide5";
import Slide6 from "./Slide6";
import Slide7 from "./Slide7";
import Slide8 from "./Slide8";
import Slide9 from "./Slide9";
import Slide10 from "./Slide10";
import Slide11 from "./Slide11";
import Slide12 from "./Slide12";
import Slide13 from "./Slide13";
import Slide21 from "./Slide21";
import SlidePoolCondition from "./SlidePoolCondition";
import { getPoolSize } from "../Api/Pool";
import { getZipcode, getCounty } from "../Api/ExtractZipcode"
import { sendEmail } from '../Api/Email';
import { AdsKeys } from '../Api/Constants';
import SlideOutOfService from './SlideOutOfService';
import LoadingAnalyzing from "./LoadingAnalyzing";
import HangTight from "./HangTight";
import QuoteReview from "./QuoteReview";
import QuoteConfirmation from "./QuoteConfirmation";
import TierPicker from './TierPicker';
import { CHEM_BRUSH, claimQuoteLane, getQuoteSession, prepareServiceOffer, readQuoteLane, serviceOptionFormVersion, serviceOptionsRequest } from '../utils/serviceOptions';
import { Statsig } from 'statsig-react';
import { EXPERIMENTS, EVENTS, trackEvent, getFormDuration, getStatsigStableId, isExistingCustomerAnchoringEnabled, readSelfServeDecision, captureSelfServeDecision, GATES, isQuoteRepairEnabled } from '../utils/statsig';
import { buildMetaUserData } from '../utils/metaUserData';
import { useAutoSubmitQuote } from '../hooks/useAutoSubmitQuote';
import brandConfig, { withPreviewBrand } from '../config/brand';
import { trackSubmitTelemetry } from '../utils/submitTelemetry';
import { quoteEntryTarget } from '../utils/quoteEntryTarget';
import DirectRequest from './DirectRequest';
import { getCurrentSplitAssignment, isDirectArmActive, markDirectCommercial, publishSplitAssignment, splitAssignmentIdForPayload, splitQaTokenForPayload } from '../utils/splitTest';
import { eastBayBrand, eastBayFallbackAssignment } from '../utils/eastBayDirect';
import { mergeSubmitPayload } from '../utils/pickSubmitEmail';
import { checkZip } from '../utils/serviceRegions';
import { stampQuoteSubmission, isConfirmedSubmission, markQuoteSubmissionConfirmed, beginQuoteSubmission } from '../utils/quoteSubmission';

// Collect UTM attribution from localStorage for dataLayer pushes (defense-in-depth).
const getUtmAttribution = () => {
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_device', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'oppref'];
  const attr = {};
  keys.forEach(k => { const v = localStorage.getItem(k); if (v) attr[k] = v; });
  return attr;
};

// Bounds on a believable satellite pool measurement, in square feet. Anything
// outside them is a detection failure that happens to be numeric, so the
// customer is asked instead of being auto-quoted off a bad reading. Deliberately
// wide: the job is to reject noise and glitches, not to second-guess real pools.
const MIN_PLAUSIBLE_POOL_SQ_FT = 20;
const MAX_PLAUSIBLE_POOL_SQ_FT = 50000;

// The only sizes the pricing engine understands. The large-pool surcharge is
// applied on an exact "large" match, so any other value silently prices a large
// pool at the base rate.
const PRICEABLE_POOL_SIZES = ["small", "medium", "large"];

const Step = () => {
  const [resumeForm] = useState(readResumeForm);
  const resumePositioned = useRef(false);
  const swiperRef = useRef(null);
  const navigate = useNavigate();
  const { index } = useParams();
  const stepIndex = parseInt(index, 10) - 1;

  useEffect(() => { if (stepIndex === 0) beginQuoteSubmission(); }, [stepIndex]);

  const isCabana = brandConfig.key === 'cabana';
  const forcedVariant = sessionStorage.getItem('force_experiment_variant');
  const selfServeDecision = useRef(readSelfServeDecision(forcedVariant));
  const showSelfServeForm = isCabana && (selfServeDecision.current?.showSelfServe ?? false);

  const exposureLoggedRef = useRef(false);

  const [isButtonClick, setIsButtonClick] = useState(false);
  const [slide1Response, setSlide1Response] = useState(resumeForm ? true : null);
  const [poolTypeResponse, setPoolTypeResponse] = useState(resumeForm?.poolType || null);
  const [selfService, setSelfService] = useState(null);
  const [serviceResponse, setServiceResponse] = useState(resumeForm?.service || []);
  const [poolOptionResponse, setPoolOptionResponse] = useState(resumeForm?.poolOption || null);
  const [, setPoolOption1Response] = useState(null);
  const [thankYouResponse, setThankYouResponse] = useState(null);
  const [manualText, setManualText] = useState("");
  const [previousShow, setPreviousShow] = useState(true);
  const [zipCode, setZipCode] = useState(resumeForm?.zipCode || null);
  const [, setCountyName] = useState(null);
  const [formData, setFormData] = useState(resumeForm || { personName: "", phone: "" });
  const [finalFormData, setFinalFormData] = useState({});
  const [serviceOffer, setServiceOffer] = useState(null);
  const serviceOfferPending = useRef(false);
  const inactiveServiceOffer = useRef(null);
  const serviceOfferRetry = useRef(null);
  const [restoringOffer, setRestoringOffer] = useState(() => !!sessionStorage.getItem('service_option_offer') && window.location.pathname === '/step/13');
  const [restoreError, setRestoreError] = useState('');
  // Direct arm of the direct vs Cabana split test: when set, the rest of the
  // funnel is replaced by the DirectRequest short form.
  const [directSplit, setDirectSplit] = useState(null);
  const [submissionError, setSubmissionError] = useState('');
  const [reviewRequired, setReviewRequired] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [confirmationRecovery] = useState(() => isQuoteRepairEnabled(GATES.QUOTE_SUBMISSION_CONFIRMATION));
  const [existingQuoteRecovery] = useState(() => isQuoteRepairEnabled(GATES.SERVICE_OPTION_EXISTING_QUOTE));
  const submissionPending = useRef({});
  const manualSubmitPending = useRef(false);

  useEffect(() => {
    if (!resumeForm || resumePositioned.current) return;
    const swiper = swiperRef.current?.swiper;
    if (!swiper) return;
    swiper.update();
    const target = firstMissingResumeSlide(resumeForm);
    const position = Array.from(swiper.slides).findIndex(slide => slide.dataset.resumeSlide === target);
    if (position < 0) return;
    resumePositioned.current = true;
    setContactId(resumeForm.contactId || '');
    swiper.slideTo(position, 0);
    navigate(withPreviewBrand(`/step/${position + 1}`), { replace: true });
    sessionStorage.removeItem('quote_resume_form');
  }, [resumeForm, navigate]);

  const showExistingQuote = () => {
    setReviewRequired(false);
    setSelfService('existing-quote');
    setRestoreError('');
    setSubmissionError('');
    setServiceOffer(null);
    serviceOfferRetry.current = null;
    navigate(withPreviewBrand('/step/13'));
    window.history.replaceState({ selfService: 'existing-quote' }, '', withPreviewBrand('/step/13'));
  };

  const openServiceOffer = (offer, form) => {
    setServiceOffer(offer);
    sessionStorage.setItem('service_option_offer', offer.id);
    setFinalFormData({ ...form, formVersion: serviceOptionFormVersion(offer), serviceOption: {
      offerId: offer.id, serviceId: CHEM_BRUSH, selectedExtras: {},
    }, quote_session: getQuoteSession() });
    setSelfService('service-options');
    navigate(withPreviewBrand('/step/13'));
    window.history.replaceState({ selfService: 'service-options' }, '', withPreviewBrand('/step/13'));
  };

  const prepareOfferForForm = async form => {
    const prepared = await prepareServiceOffer(form, inactiveServiceOffer, exposureLoggedRef.current);
    if (prepared.existingQuote) {
      showExistingQuote();
    } else if (prepared.offer) {
      setRestoreError('');
      openServiceOffer(prepared.offer, form);
    } else if (prepared.retry) {
      serviceOfferRetry.current = async () => {
        setRestoringOffer(true);
        try { await prepareOfferForForm(form); } finally { setRestoringOffer(false); }
      };
      setRestoreError(prepared.reviewPending
        ? 'We could not check your existing request. Please retry or call us to review it.'
        : 'We could not restore your service options. Please retry or call us for help.');
    } else {
      serviceOfferRetry.current = null;
      setRestoreError('');
    }
    return prepared;
  };

  const restoreServiceOffer = useCallback(async () => {
    const offerId = sessionStorage.getItem('service_option_offer');
    if (!offerId) return;
    setRestoringOffer(true);
    setRestoreError('');
    try {
      const saved = await serviceOptionsRequest('resume', { offerId });
      if (saved.state === 'existing_quote') {
        if (saved.already_accepted === true && saved.success === true
            && saved.service_option_accepted === true && /^[1-9]\d*$/.test(String(saved.deal_id))
            && Number.isSafeInteger(Number(saved.deal_id))) {
          setReviewRequired(false);
          setSelfService('service-options-confirmed');
        } else {
          showExistingQuote();
        }
        return;
      }
      if (saved.confirmation_pending && !existingQuoteRecovery) {
        showExistingQuote();
        return;
      }
      if (await claimQuoteLane('tier') !== 'tier') throw new Error('Quote session changed');
      setServiceOffer(saved.offer);
      setFormData(saved.form);
      setSlide1Response(true);
      setPoolTypeResponse(saved.form.poolType);
      setServiceResponse(saved.form.service);
      setPoolOptionResponse(saved.form.poolOption);
      setZipCode(saved.form.zipCode);
      const rememberedService = sessionStorage.getItem(`service_option_selection:${offerId}`);
      const selectedService = saved.serviceId || (saved.offer.arm === 'B'
        && saved.offer.options.some(option => option.serviceId === rememberedService) ? rememberedService : CHEM_BRUSH);
      setFinalFormData({ ...saved.form, quote_session: getQuoteSession(),
        formVersion: serviceOptionFormVersion(saved.offer), serviceOption: {
        offerId, serviceId: selectedService, selectedExtras: {},
      } });
      if (saved.accepted) setReviewRequired(false);
      setSelfService(saved.accepted ? 'service-options-confirmed' : 'service-options');
    } catch (_) {
      setRestoreError('We could not restore your quote. Please retry.');
    } finally {
      setRestoringOffer(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (window.location.pathname === '/step/13' && sessionStorage.getItem('service_option_offer')) restoreServiceOffer();
  }, [restoreServiceOffer]);

  // Auto-submit quote handler for inactivity timeout
  const handleAutoSubmitQuote = useCallback(async (reason) => {
    // Prepare the data similar to what happens in handleNext for cabana-payment
    const payload = {
      ...formData,
      ...finalFormData,
      autoSubmitted: true,
      autoSubmitReason: reason,
    };

    try { await fetchData(payload); } catch { return false; }

    // GTM tracking: confirmed automatic draft save
    window.dataLayer = window.dataLayer || [];
    const autoMetaUserData = buildMetaUserData(payload);
    window.dataLayer.push({
      'event': 'formSubmitted',
      'formStep': 'Quote Auto-Submitted',
      'formData': payload,
      'meta_user_data': autoMetaUserData,
      'experimentVariant': showSelfServeForm ? 'treatment' : 'control',
      'quoteAmount': payload.amount,
      'autoSubmitted': true,
      'autoSubmitReason': reason
    });

    // Update draft request to mark as submitted
    updateDraftRequest({
      isSubmitted: true,
      autoSubmitted: true,
      autoSubmitReason: reason
    });

    // Prevent sendBeacon from double-firing on browser close after inactivity submit
    markQuoteAsSubmitted();

    return true;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData, finalFormData]);

  // Auto-submit hook - active after step 1 for both control and treatment users
  // Uses merged formData + finalFormData to capture whatever data we have
  const autoSubmitData = { ...formData, ...finalFormData };
  const hasMinimumData = !!(autoSubmitData.personName || autoSubmitData.phone || autoSubmitData.address);
  const { markAsSubmitted: markQuoteAsSubmitted, setSubmissionPending } = useAutoSubmitQuote(
    // The direct arm submits only from its own short form: an abandoned
    // direct-arm visit must not auto-create a normal lead.
    stepIndex >= 1 && hasMinimumData && !reviewRequired && !restoringOffer && !restoreError
      && !['service-options-confirmed', 'existing-quote'].includes(selfService) && !directSplit,
    autoSubmitData,
    handleAutoSubmitQuote,
    zipCode,
    showSelfServeForm ? 'treatment' : 'control'
  );

  const handleNext = async (...args) => {
    if (reviewRequired) return;
    const intentional = args[0] === 'thankYou' || selfService === 'cabana-payment';
    if (intentional && manualSubmitPending.current) return;
    if (intentional) manualSubmitPending.current = true;
    try { return await handleNextStep(...args); }
    finally { if (intentional) manualSubmitPending.current = false; }
  };

  const handleNextStep = async (response, data, extraData = null) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      let newIndex = stepIndex + 1;
      let updatedFormData = { ...formData };
      // Merge full extraData (includes email, quote amount, etc.)
      if (extraData) {
        updatedFormData = { ...updatedFormData, ...extraData };
      }
      // After Slide13, start the custom flow
      if (response === 'self-service-start') {
        setSelfService('tell-us-more');
        setIsButtonClick(true);
        navigate(withPreviewBrand(`/step/${data}`));
        setProgress();
        return;
      }

      // Handle custom flow slides
      if (selfService === 'hang-tight' || selfService === 'loading-analyzing') {
        // PAYMENT REMOVED: Payment step no longer used - showing quote only
        // trackEvent(EVENTS.PAYMENT_INITIATED, {
        //   pool_size: updatedFormData.poolSize,
        //   pool_type: updatedFormData.poolType,
        //   service: updatedFormData.service,
        //   duration: getFormDuration(),
        // });

        // Track when quote is shown (key funnel event)
        trackEvent(EVENTS.QUOTE_SHOWN, {
          pool_size: updatedFormData.poolSize,
          pool_type: updatedFormData.poolType,
          service: updatedFormData.service,
          duration: getFormDuration(),
        });

        // GTM tracking: Quote shown (experiment branch)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'quoteShown',
          'formStep': 'Quote Display',
          'experimentVariant': 'treatment',
          'quoteAmount': updatedFormData.amount
        });

        setSelfService('cabana-payment');
        // Replace the transient loading-analyzing/hang-tight history entry with
        // the durable quote-review entry. Keeps the back button from cycling
        // through loading screens.
        window.history.replaceState({ selfService: 'cabana-payment' }, '', withPreviewBrand('/step/13'));
        setFinalFormData(updatedFormData);
        setProgress();
        return;
      }
      if (selfService === 'cabana-payment') {
        updatedFormData = { ...updatedFormData, autoSubmitted: false, autoSubmitReason: undefined, selfServeQuoteAccepted: true };
        let quoteAcceptedResult;
        try { quoteAcceptedResult = await fetchData(updatedFormData); } catch { return; }

        // GTM tracking: Form submitted (experiment branch)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmitted',
          'formStep': 'Quote Accepted',
          'formData': updatedFormData,
          'meta_user_data': buildMetaUserData(updatedFormData),
          'experimentVariant': 'treatment',
          'quoteAmount': updatedFormData.amount,
          'sell_deal_id': quoteAcceptedResult?.deal_id ? Number(quoteAcceptedResult.deal_id) : undefined,
        });

        // Statsig tracking: Quote claimed (self-serve variant)
        trackEvent(EVENTS.QUOTE_CLAIMED, {
          variant: 'treatment',
          pool_size: updatedFormData.poolSize,
          pool_type: updatedFormData.poolType,
          service: updatedFormData.service,
          duration: getFormDuration(),
          quote_amount: updatedFormData.amount || 0,
          zip_code: updatedFormData.zipCode,
          email: updatedFormData.email,
          utm_source: localStorage.getItem('utm_source') || undefined,
          utm_medium: localStorage.getItem('utm_medium') || undefined,
          utm_campaign: localStorage.getItem('utm_campaign') || undefined,
          utm_term: localStorage.getItem('utm_term') || undefined,
          utm_device: localStorage.getItem('utm_device') || undefined,
          gclid: localStorage.getItem('gclid') || undefined,
          gbraid: localStorage.getItem('gbraid') || undefined,
          wbraid: localStorage.getItem('wbraid') || undefined,
          fbclid: localStorage.getItem('fbclid') || undefined,
          msclkid: localStorage.getItem('msclkid') || undefined,
        });

        // The confirmed receipt's backend owns form_completed and its original cohort identity.

        setSelfService('success-payment');
        // Replace the quote-review entry; browser back from success goes to the
        // pre-/step/13 form step rather than re-opening the just-claimed quote.
        window.history.replaceState({ selfService: 'success-payment' }, '', withPreviewBrand('/step/13'));
        updatedFormData.selfServeQuoteAccepted = true;
        setFormData(updatedFormData);
        setFinalFormData(updatedFormData);
        updateDraftRequest({
          isSubmitted: true,
          email: updatedFormData.email
        })
        setProgress();
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 100);
        return;
      }
      if (selfService === 'success-payment') {
        return;
      }
      if (stepIndex === 0) {
        // Slide1 attaches the split test assignment; keep it out of the form
        // data so it never rides along on lead or draft payloads as an object.
        const { splitAssignment, ...slideData } = data || {};
        data = slideData;
        window.dataLayer.push({
          'event': 'formStepCompleted',
          'formStep': 'Step 1',
          'formData': data,
          ...getUtmAttribution()
        });

        // Statsig tracking: Step 1 completed
        trackEvent(EVENTS.STEP_1_COMPLETED, {
          address: data.address,
          zip_code: data.zipCode,
          has_name: !!data.personName,
          has_phone: !!data.phone,
        });

        setSlide1Response(response);
        setFormData({});
        setFormData(data);
        let activeSplit = splitAssignment;
        if (!data.isOutOfServiceArea && activeSplit?.arm !== 'direct' && eastBayBrand(data.zipCode)) {
          activeSplit = eastBayFallbackAssignment(data.zipCode);
          publishSplitAssignment(activeSplit);
        }
        if (!data.isOutOfServiceArea && activeSplit?.in_test && activeSplit.arm === 'direct') {
          // Direct arm: no pool questions, no price, no draft-save, no
          // service options. The short form takes over from here.
          setFinalFormData(data);
          setDirectSplit(activeSplit);
          trackEvent('split_direct_form_shown', {
            experiment_id: activeSplit.experiment_id || undefined,
            brand: activeSplit.brand || undefined,
            zip_code: data.zipCode,
          });
          navigate(withPreviewBrand('/step/2'));
          window.scrollTo(0, 0);
          return;
        }
        newIndex = response ? 1 : 0;
        if (data.isOutOfServiceArea) {
          newIndex = 22;
          setPoolTypeResponse('out-of-service');

          // Statsig tracking: Out of service shown
          trackEvent(EVENTS.OUT_OF_SERVICE_SHOWN, {
            zip_code: data.zipCode,
            address: data.address,
          });
        } else {
          let zipcode = await getZipcode(data.address);
          setZipCode(zipcode);
          let countryInfo = await getCounty(data.address);
          setCountyName(countryInfo.countryName);
          setFormData({
            ...data,
            shortCode: countryInfo.countryShortCode,
            countryName: countryInfo.countryName,
          });
        }
      } else if (typeof response === 'boolean') {
        // Only Slide1 sends a boolean response that reaches this chain; it is
        // handled above when stepIndex is 0. Reaching here means Slide1's
        // off-screen form was submitted from a later step (seen from a
        // headless test clicking the hidden #loadButton, CABANA-QUOTE-FORM-B).
        // The string checks below would throw on it, so ignore it.
        return;
      } else if (response === "manualAddress") {
        window.dataLayer.push({
          'event': 'formStepCompleted',
          'formStep': 'Manual Address',
          'formData': data,
          ...getUtmAttribution()
        });
        setFormData({});
        setFormData(data);
        newIndex = stepIndex + 1;
      } else if (response === "manualAddress1") {
        window.dataLayer.push({
          'event': 'formStepCompleted',
          'formStep': 'Manual Address Personalized',
          'formData': data
        });
        updatedFormData = { ...updatedFormData, ...data };
        setManualText("We've received your quote request, and will be in touch with a personalized estimate for your service (typically within a couple hours.)");
        updatedFormData = { ...updatedFormData, ...{ poolURL: "/images/thank-you.svg" } };
        setFormData(updatedFormData);
        newIndex = stepIndex + 1;
      } else if (response === "residential" || response === "commercial") {
        window.dataLayer.push({
          'event': 'formStepCompleted',
          'formStep': 'Pool Type',
          'formData': data
        });

        // Statsig tracking: Step 2 completed (Pool Type)
        trackEvent(EVENTS.STEP_2_COMPLETED, {
          pool_type: response,
        });

        setPoolTypeResponse(response);
        updatedFormData = { ...updatedFormData, ...data };
        setFormData(updatedFormData);
        newIndex = stepIndex + 1;
      } else if (
        response === "crystal_clear" ||
        response === "slightly_cloudy" ||
        response === "cloudy_light_green" ||
        response === "green" ||
        response === "swamp"
      ) {
        window.dataLayer.push({
          'event': 'formStepCompleted',
          'formStep': 'Pool Condition',
          'formData': data
        });
        updatedFormData = { ...updatedFormData, ...data };
        setFormData(updatedFormData);
        newIndex = stepIndex + 1;
      } else if (
        response?.includes("greentoclean") ||
        response?.includes("equipment_repair") ||
        response?.includes("regular_pool_spa_service") ||
        response?.includes("filter_or_salt_cell_cleaning") ||
        response?.includes("something_else")
      ) {
        window.dataLayer.push({
          'event': 'formStepCompleted',
          'formStep': 'What can we help?',
          'formData': data
        });

        // Statsig tracking: Step 3 completed (Services)
        trackEvent(EVENTS.STEP_3_COMPLETED, {
          services: Array.isArray(response) ? response.join(',') : response,
          service_count: Array.isArray(response) ? response.length : 1,
        });

        setServiceResponse(response);
        updatedFormData = { ...updatedFormData, ...data };
        setFormData(updatedFormData);
        newIndex = stepIndex + 1;
      } else if (
        response === "pool_only" ||
        response === "pool_spa" ||
        response === "pool_hot_tub" ||
        response === "hot_tub" ||
        response === "something_else"
      ) {
        window.dataLayer.push({
          'event': 'formStepCompleted',
          'formStep': 'Tell us about your pool',
          'formData': data
        });
        setPoolOptionResponse(response);
        updatedFormData = { ...updatedFormData, ...data };
        setFormData(updatedFormData);
        newIndex = stepIndex + 1;
      } else if (
        response?.includes("pool_pump") ||
        response?.includes("pool_filter") ||
        response?.includes("pool_heater") ||
        response?.includes("salt_system") ||
        response?.includes("automaion_system") ||
        response?.includes("i_m_not_sure")
      ) {
        window.dataLayer.push({
          'event': 'formStepCompleted',
          'formStep': 'What equipment do you need help with?',
          'formData': data
        });
        updatedFormData = { ...updatedFormData, ...data };
        setFormData(updatedFormData);
        newIndex = stepIndex + 1;
      } else if (
        response?.includes("ground_pool") ||
        response?.includes("saltwater_pool") ||
        response?.includes("trees_over_pool") ||
        data.isPoolSizePage === 1
      ) {
        window.dataLayer.push({
          'event': 'formStepCompleted',
          'formStep': 'Do any of these apply to your pool?',
          'formData': data
        });
        setPoolOption1Response(response);
        updatedFormData = { ...updatedFormData, ...data };
        // setFormData(updatedFormData);
        // newIndex = stepIndex + 1;
        let pool_size;
        let result = await getPoolSize(formData.address);
        if (result.image_url) {
          updatedFormData = { ...updatedFormData, ...{ poolURL: result.image_url } };
        }
        // Detection is "answered" whenever the API returned a numeric area,
        // including the 0 and -1 sentinels. The previous truthiness check
        // treated 0 (and a missing field, which is what Pool.js returns when
        // the request fails) as though the step had not happened at all: it
        // skipped the assignment, so poolSize stayed undefined rather than the
        // empty string the downstream fallback looks for, and it skipped the
        // index advance so the flow landed on the wrong slide.
        // Coerce rather than type-test: a numeric string still carries a usable
        // measurement, and rejecting it would send a perfectly measurable pool
        // to the manual step. Number(null) is 0 and Number(undefined) is NaN,
        // both of which fail the plausibility test below, so a missing field
        // still reads as unknown.
        const rawArea = Number(result.contour_area);
        const contourArea = Number.isFinite(rawArea) ? rawArea : null;
        // A non-positive area is the "could not measure" sentinel, and a
        // missing area means the request itself failed (Pool.js returns
        // { image_url: null } from its catch). Both mean the same thing to the
        // rest of the flow: size is unknown, so ask the customer. Always
        // assigning the empty string keeps the downstream fallback and the
        // self-serve size check working instead of leaving poolSize undefined.
        //
        // The bounds matter because an implausible reading is a detection
        // failure wearing a number: without them Infinity and glitch values
        // classify as "large" and are auto-quoted with the surcharge, with no
        // human ever looking at them.
        const sizeDetected =
          contourArea !== null &&
          contourArea >= MIN_PLAUSIBLE_POOL_SQ_FT &&
          contourArea <= MAX_PLAUSIBLE_POOL_SQ_FT;
        if (!sizeDetected) {
          pool_size = '';
        } else if (contourArea < 2000) {
          pool_size = "small";
        } else if (contourArea < 3000) {
          pool_size = "medium";
        } else {
          // Previously `> 3000`, which left an area of exactly 3000 with no
          // size at all.
          pool_size = "large";
        }
        updatedFormData = { ...updatedFormData, ...{ poolSize: pool_size, poolSizeSq: contourArea } };

        // Statsig tracking: Pool size detected
        trackEvent(EVENTS.POOL_SIZE_DETECTED, {
          pool_size: pool_size,
          pool_size_sq_ft: contourArea,
          detected_automatically: sizeDetected,
          has_image: !!result.image_url,
        });

        // Show the manual size step whenever size is unknown, so an undetected
        // pool is never priced without one.
        if (response?.includes("ground_pool") || !sizeDetected) {
          newIndex = stepIndex + 1;
        }
        else
          newIndex = stepIndex + 2;
        setFormData(updatedFormData);
      } else if (response === "thankYou") {

        if (data.email) {
          updatedFormData = { ...updatedFormData, ...{ email: data.email } };
        } else {
          updatedFormData = { ...updatedFormData, ...data };
        }
        updatedFormData = { ...updatedFormData, autoSubmitted: false, autoSubmitReason: undefined };
        setFormData(updatedFormData);
        let thankYouResult;
        try { thankYouResult = await fetchData(updatedFormData); } catch { return; }
        setThankYouResponse(response);
        setPreviousShow(false);
        window.dataLayer.push({
          'event': 'formSubmitted',
          'formStep': 'Thank you',
          'formData': updatedFormData,
          'meta_user_data': buildMetaUserData(updatedFormData),
          'sell_deal_id': thankYouResult?.deal_id ? Number(thankYouResult.deal_id) : undefined,
          ...getUtmAttribution()
        });

        newIndex = stepIndex + 1;
      }

      // handle pool size detect
      if (stepIndex === 6) {

      }
      if (stepIndex >= 5) {
        const poolSizeInput = document.querySelector('input[name="pool_size"]:checked');
        const poolSizeValue = poolSizeInput ? poolSizeInput.value : data.poolSize2 ? data.poolSize2 : null;
        // Read the value written earlier in this same handler, not the state
        // snapshot this closure captured, and treat undefined as unknown. The
        // previous check compared the stale formData against only '' and null,
        // so a detection failure (which leaves poolSize undefined) skipped the
        // manual-size fallback entirely and the lead carried no size at all.
        //
        // Only overwrite when the customer actually supplied a size. This
        // handler also runs on the detection slide itself, where no pool_size
        // input exists yet; writing there would replace the empty-string
        // unknown marker with null and announce the manual-quote message before
        // the question has even been asked.
        if (!updatedFormData.poolSize && poolSizeValue) {
          updatedFormData = { ...updatedFormData, ...{ poolSize: poolSizeValue } };
          setManualText("We've received your quote request, and will be in touch with a personalized estimate for your service (typically within a couple hours.)");
        }
        setFormData(updatedFormData);
      }
      window.parent.postMessage(
        {
          type: "step",
          step: newIndex + 1,
        },
        '*'
      );
      setIsButtonClick(true);
      const final = { ...updatedFormData, ...data };
      setFinalFormData(final);

      let allowLegacySelfServe = readQuoteLane() !== 'tier';
      if (stepIndex >= 5 && response !== 'thankYou' && !thankYouResponse) {
        if (serviceOfferPending.current) return;
        serviceOfferPending.current = true;
        try {
          const prepared = await prepareOfferForForm(final);
          allowLegacySelfServe = prepared.allowLegacy;
          if (prepared.offer || prepared.retry || prepared.existingQuote) return;
        } finally {
          serviceOfferPending.current = false;
        }
      }

      // ===== A/B TEST DECISION POINT =====
      // Check if user qualifies for self-serve experiment
      // Qualification: residential, regular pool service only, pool/spa only, NOT above ground, after pool size step
      const qualifiesForSelfServe = stepIndex >= 5 && final && !directSplit
        && ['CA1', 'CA2'].includes(checkZip(final.zipCode).foundIn) &&
        final.poolType === 'residential' &&
        final.service && Array.isArray(final.service) && final.service.length === 1 && final.service.includes("regular_pool_spa_service") &&
        (final.poolOption === 'pool_only' || final.poolOption === 'pool_spa' || final.poolOption === 'pool_hot_tub') &&
        !(final.poolOption1 && Array.isArray(final.poolOption1) && final.poolOption1.includes('ground_pool'));

      if (qualifiesForSelfServe) {
        // A known pool size is required before an automatic quote can be
        // correct, because the large-pool surcharge is applied only on an exact
        // "large" match. This previously deferred to a tellUsPoolSize flag
        // derived from live DOM reads, which is false whenever the condition
        // slide has not mounted, and a false value skipped the size requirement
        // entirely: an unsized lead could still be quoted and would silently
        // lose the surcharge. Without a size, fall through to the ordinary
        // human-quote path.
        //
        // Membership, not truthiness: any other truthy value (a stale field, an
        // unrecognised answer) would pass a truthiness check and then fail the
        // exact "large" match in QuoteReview, reinstating the base-rate quote on
        // a large pool that this change exists to prevent.
        if (PRICEABLE_POOL_SIZES.includes(final.poolSize)) {
          if (isCabana && allowLegacySelfServe) {
            // Persist before the existing exposure/routing boundary, including
            // gate-off releases. Another tab may have reserved a tier offer.
            allowLegacySelfServe = (await claimQuoteLane('v5')) !== 'tier';
            if (!allowLegacySelfServe) {
              await prepareOfferForForm(final);
              return;
            }
          }
          if (!selfServeDecision.current && isCabana && allowLegacySelfServe) {
            selfServeDecision.current = captureSelfServeDecision(forcedVariant);
            if (!selfServeDecision.current.assigned) {
              const metadata = { experiment_name: EXPERIMENTS.SELF_SERVE_FORM,
                reason: selfServeDecision.current.reason, qa_override: !!forcedVariant };
              Sentry.addBreadcrumb({ category: 'experiment', message: 'Quote route without an assignment', data: metadata });
              trackEvent('quote_assignment_unavailable', metadata);
            }
          }
          const routeSelfServe = isCabana && selfServeDecision.current?.showSelfServe === true;
          if (!exposureLoggedRef.current && isCabana && allowLegacySelfServe && selfServeDecision.current?.expose) {
            exposureLoggedRef.current = true;
            selfServeDecision.current.expose = false;
            Statsig.manuallyLogExperimentExposure(EXPERIMENTS.SELF_SERVE_FORM);

            trackEvent(EVENTS.EXPERIMENT_EXPOSED, {
              experiment_name: EXPERIMENTS.SELF_SERVE_FORM,
              variant: routeSelfServe ? 'treatment' : 'control',
              brand: brandConfig.key,
              site_origin: brandConfig.siteOrigin,
              pool_type: final.poolType,
              service: final.service,
              pool_option: final.poolOption,
              pool_size: final.poolSize,
              zip_code: final.zipCode,
              utm_source: localStorage.getItem('utm_source') || undefined,
              utm_medium: localStorage.getItem('utm_medium') || undefined,
              utm_campaign: localStorage.getItem('utm_campaign') || undefined,
              utm_term: localStorage.getItem('utm_term') || undefined,
              utm_device: localStorage.getItem('utm_device') || undefined,
              gclid: localStorage.getItem('gclid') || undefined,
              gbraid: localStorage.getItem('gbraid') || undefined,
              wbraid: localStorage.getItem('wbraid') || undefined,
              fbclid: localStorage.getItem('fbclid') || undefined,
              msclkid: localStorage.getItem('msclkid') || undefined,
            });
          }

          // A/B TEST: Route based on experiment variant
          if (routeSelfServe && allowLegacySelfServe) {
            // Treatment: Show self-serve flow
            trackEvent(EVENTS.SELF_SERVE_OPTED_IN, {
              pool_size: final.poolSize,
              duration: getFormDuration(),
            });

            // GTM tracking: Entered self-service flow (experiment branch)
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'experimentStarted',
              'experimentName': EXPERIMENTS.SELF_SERVE_FORM,
              'experimentVariant': 'treatment',
              'formStep': 'Pool Size Detection'
            });

            // Skip property details, go straight to pool size detection
            setIsButtonClick(true);
            let selfServeFormData = { ...final };
            let result = await getPoolSize(formData.address);
            let poolUrl = '';
            if (result.image_url) {
              selfServeFormData = { ...selfServeFormData, poolURL: result.image_url };
              poolUrl = result.image_url;
              setFormData(selfServeFormData);
            }
            setFinalFormData(selfServeFormData);
            const initialSelfService = poolUrl ? 'loading-analyzing' : 'hang-tight';
            setSelfService(initialSelfService);
            // Single history entry for /step/13 via react-router; attach state
            // in-place so popstate can restore whichever self-serve sub-state
            // is current. Subsequent sub-state changes use replaceState, so
            // back from QuoteReview lands on this step's predecessor cleanly.
            navigate(withPreviewBrand('/step/13'));
            window.history.replaceState({ selfService: initialSelfService }, '', withPreviewBrand('/step/13'));
            setProgress();
            return;
          } else {
            // Control: Continue to thank you page (normal flow)
            // No special action needed, will navigate normally below
          }
        }
      }
      navigate(withPreviewBrand(`/step/${newIndex + 1}`));
      updateDraftRequest()

    }
  };

  useEffect(() => {
    const handlePopState = (event) => {
      const index = window.location.pathname.split('/')[2]

      // The direct-arm short form lives on /step/2. Leaving it (back to the
      // address) clears it; returning with forward restores it.
      if (index === '2' && isDirectArmActive()) {
        setDirectSplit(getCurrentSplitAssignment());
        return;
      }
      setDirectSplit(null);

      if (index === '13') {
        // Restore the self-serve sub-state attached to this history entry.
        // If no state (shouldn't happen after the replaceState refactor, but
        // defend against shared-session edge cases), default to cabana-payment
        // since that's the only durable /step/13 state we want users navigating
        // back into.
        if (sessionStorage.getItem('service_option_offer')) {
          restoreServiceOffer();
        } else {
          setSelfService(event.state?.selfService || 'cabana-payment');
        }
        return;
      }

      // Any step other than 13: the user has navigated out of the self-serve
      // sub-flow. Clear selfService so the Swiper re-renders the form slide
      // matching the URL.
      setSelfService('');
      serviceOfferRetry.current = null;
      setRestoreError('');
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [restoreServiceOffer]);

  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      let newIndex = stepIndex - 1;
      if (stepIndex === 1 && !slide1Response) {
        newIndex = 0;
      }
      window.parent.postMessage(
        {
          type: "step",
          step: newIndex + 1,
        },
        '*'
      );
      window.parent.postMessage('scrollup', '*');
      window.scrollTo(0, 0);
      setIsButtonClick(true);
      if (window.location.pathname.split('/')[2] === '13') {
        if (selfService === 'success-payment') {
          // From the claim confirmation, let users return to the quote to edit
          // the email before resubmitting.
          setSelfService('cabana-payment');
          window.history.replaceState({ selfService: 'cabana-payment' }, '', withPreviewBrand('/step/13'));
        } else {
          // Exit the self-serve sub-flow directly to the last form step
          // (pool size, or pool attributes if size wasn't picked). A single
          // back click; no cycling through loading/hang-tight.
          setSelfService('');
          navigate(withPreviewBrand(formData.poolSize ? '/step/7' : '/step/6'));
        }
      } else if (window.location.pathname.split('/')[2] === '23') {
        navigate(withPreviewBrand('/step/1'));
      }
      else {
        navigate(withPreviewBrand(`/step/${newIndex + 1}`));
        setSelfService('');
      }
      setProgress();
    }
  };
  const handleResidentialClick = () => {
    setPoolTypeResponse("residential");
  };
  const handleCommercialClick = () => {
    setPoolTypeResponse("commercial");
  };
  const handlePoolURL = () => {
    return formData.poolURL;
  };
  const fetchData = async (dataPayload = null) => {
    const kind = dataPayload?.autoSubmitted === true ? 'auto' : 'manual';
    if (submissionPending.current[kind]) return submissionPending.current[kind];
    const preceding = Promise.allSettled(Object.values(submissionPending.current));
    const request = preceding.then(() => persistForm(dataPayload));
    submissionPending.current[kind] = request;
    setSubmissionPending?.(true);
    if (kind === 'manual') { setSubmitting(true); setSubmissionError(''); }
    try { return await request; }
    finally {
      delete submissionPending.current[kind];
      setSubmissionPending?.(Object.keys(submissionPending.current).length > 0);
      if (kind === 'manual') setSubmitting(false);
    }
  };

  const persistForm = async (dataPayload = null) => {
    let acceptedResult;
    // Hoisted above the try so the catch can report telemetry without
    // double-sending when the outcome was already recorded.
    let telemetryOutcomeSent = false;
    let telemetryIds = { submit_kind: "manual" };
    try {
      const poolSizeInput = document.querySelector('input[name="pool_size"]:checked');
      const poolSizeValue = poolSizeInput ? poolSizeInput.value : null;
      let updatedFormData = { ...formData };
      // Stamp the form variant so Sell can segment leads by which UI the
      // customer experienced. Stable label per variant, not the experiment ID.
      updatedFormData.formVersion = showSelfServeForm
        ? "Test April 2026"
        : "Control January 2026";
      if (updatedFormData.poolType === 'commercial') {
        if (updatedFormData.zipCode) {
          updatedFormData.commercialZipCode = updatedFormData.zipCode;
        }
      }
      // If poolSizeValue is not null, add it to the updatedFormData
      if (poolSizeValue) {
        updatedFormData.poolSize = poolSizeValue;
      }
      window.parent.postMessage(
        {
          type: "gtag_event",
          pooltype: poolTypeResponse,
        },
        '*'
      );
      updatedFormData.contactId = getContactId();
      AdsKeys.forEach(item => {
        if (localStorage.getItem(item)) {
          updatedFormData[item] = localStorage.getItem(item);
        }
      });

      // Add source (document.referrer) from localStorage. Also mirror it to
      // `referrer` and send the first-touch `landing_page`: those are the
      // keys the lead-processor backup row and Sell attribution actually
      // read (api/_lib/transform.js), and they sat empty on every
      // submission before 2026-07-17 because only the legacy `source` key
      // was sent.
      const source = localStorage.getItem('source');
      if (source) {
        updatedFormData.source = source;
        updatedFormData.referrer = source;
      }
      const landingPage = localStorage.getItem('landing_page');
      if (landingPage) {
        updatedFormData.landing_page = landingPage;
      }

      // Meta CAPI session keys: read _fbp / _fbc cookies directly here so we
      // don't depend on any earlier localStorage sync. These cookies are set
      // by the Meta Pixel on .cabanapools.com and readable from any subdomain.
      // The Vercel /api/lead-submit proxy adds client_ip_address from
      // x-forwarded-for at its edge (the browser can't see its outbound IP).
      try {
        var _fbpMatch = document.cookie.match(/(?:^|;\s*)_fbp=([^;]+)/);
        if (_fbpMatch) updatedFormData.meta_fbp = decodeURIComponent(_fbpMatch[1]);
        var _fbcMatch = document.cookie.match(/(?:^|;\s*)_fbc=([^;]+)/);
        if (_fbcMatch) updatedFormData.meta_fbc = decodeURIComponent(_fbcMatch[1]);
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
          updatedFormData.client_user_agent = navigator.userAgent;
        }
      } catch (e) {
        // Cookie/UA capture is best-effort: a failure here must not block
        // the form submit. Meta CAPI will simply ship without these keys.
      }

      // Bot defense signal (Turnstile token). Fails open: a missing token is
      // forwarded as undefined and /api/lead-submit decides what to do
      // server-side.
      try {
        const defense = typeof window !== 'undefined' ? window.__cabanaBotDefense : null;
        if (defense) {
          const token = defense.getTurnstileToken && defense.getTurnstileToken();
          if (token) updatedFormData.turnstile_token = token;
        }
      } catch (e) {
        // Defense signal capture is best-effort. Form submit must not fail
        // because Cloudflare's CDN blipped.
      }

      updatedFormData.ga4_id = window.ga4_id || localStorage.getItem('ga4_id');
      // Cabana (control) arm of the split test: the processor tags the deal.
      const splitAssignmentId = splitAssignmentIdForPayload();
      if (splitAssignmentId) updatedFormData.split_assignment_id = splitAssignmentId;
      updatedFormData.statsig_user_id = sessionStorage.getItem('statsig_user_id');
      updatedFormData.statsig_stable_id = getStatsigStableId();
      // Existing-customer price anchoring gate. cabana-lead-processor only
      // asks the pricing engine to anchor when this is true, so the deal it
      // writes carries the same number the quote screen showed.
      updatedFormData.ec_anchoring = isExistingCustomerAnchoringEnabled();
      updatedFormData.site_origin = brandConfig.siteOrigin;

      // Fetch the current GA session ID fresh before each submit. Using a
      // bounded async lookup (1 s timeout) ensures sessions that rotated
      // since page load are captured correctly. The in-memory ref is updated
      // so the beacon path also sees the latest value.
      updatedFormData.gpc_signal = Boolean(navigator.globalPrivacyControl || false);
      try {
        if (typeof window.gtag !== 'undefined') {
          await new Promise((resolve) => {
            window.gtag('get', brandConfig.measurementId, 'session_id', (sessionId) => {
              if (sessionId) {
                window.ga_session_id_current = sessionId;
              }
              resolve();
            });
            setTimeout(resolve, 1000);
          });
        }
      } catch (error) {
        console.error('Error getting GA session ID:', error);
      }
      updatedFormData.ga_session_id = window.ga_session_id_current || '';
      if (updatedFormData.personName) {
        const nameParts = updatedFormData.personName.trim().split(' ');
        updatedFormData.firstName = nameParts[0] || "";
        updatedFormData.lastName = nameParts[1] || "";
      }
      if (updatedFormData.poolType) {
        updatedFormData.poolType =
          updatedFormData.poolType.charAt(0).toUpperCase() + updatedFormData.poolType.slice(1);
      }
      const serviceLabels = {
        regular_pool_spa_service: "Regular pool or spa service",
        equipment_repair: "Equipment upgrade or repair",
        filter_or_salt_cell_cleaning: "Filter or salt cell cleaning",
        greentoclean: '"Green to clean" pool rescue',
        something_else: "Something else"
      };
      if (Array.isArray(updatedFormData.service)) {
        updatedFormData.needHelpWith = updatedFormData.service.map(item => serviceLabels[item] || item).join(", ");
      }
      if (updatedFormData.serviceSomethingElse) {
        updatedFormData.somethingElse = updatedFormData.serviceSomethingElse;
      }
      updatedFormData = mergeSubmitPayload(updatedFormData, dataPayload);

      const poolHelpLabels = {
        pool_pump: "Pool pump",
        pool_filter: "Pool filter",
        pool_heater: "Pool heater",
        salt_system: "Salt system",
        automaion_system: "Automation system",
        i_m_not_sure: "I'm not sure / something else"
      };
      if (Array.isArray(updatedFormData.poolHelp)) {
        updatedFormData.equipmentHelp = updatedFormData.poolHelp.map(item => poolHelpLabels[item] || item).join(", ");
      }
      if (updatedFormData.poolHelpNotSure) {
        updatedFormData.unsure = updatedFormData.poolHelpNotSure;
      }
      const poolOptionLabels = {
        pool_only: "Pool only",
        pool_spa: "Pool + attached spa",
        pool_hot_tub: "Pool + separate hot tub",
        hot_tub: "Above ground hot tub",
        something_else: "Something else"
      };
      if (updatedFormData.poolOption) {
        updatedFormData.aboutPool = poolOptionLabels[updatedFormData.poolOption] || updatedFormData.poolOption;
      }
      updatedFormData.has_spa = (updatedFormData.poolOption === 'pool_spa' || updatedFormData.poolOption === 'pool_hot_tub') ? 'Yes' : 'No';
      const poolOption1Labels = {
        ground_pool: "I have an above ground pool",
        saltwater_pool: "I have a saltwater pool",
        trees_over_pool: "I have trees over the pool"
      };
      if (Array.isArray(updatedFormData.poolOption1)) {
        updatedFormData.aboutPoolType = updatedFormData.poolOption1.map(item => poolOption1Labels[item] || item).join(", ");
      }
      updatedFormData.has_salt_system = Array.isArray(updatedFormData.poolOption1) && updatedFormData.poolOption1.includes('saltwater_pool') ? 'Yes' : 'No';
      // poolSize already set in updatedFormData
      updatedFormData.token = 'CABANA-25266-TOKEN';
      updatedFormData.autoSubmitted = dataPayload?.autoSubmitted === true;
      updatedFormData.quote_variant = isCabana && updatedFormData.autoSubmitted && !selfServeDecision.current
        ? '' : showSelfServeForm ? 'treatment' : 'control';
      updatedFormData.quote_experiment_name = isCabana && selfServeDecision.current?.assigned
        ? EXPERIMENTS.SELF_SERVE_FORM : '';
      if (!updatedFormData.autoSubmitted) delete updatedFormData.autoSubmitReason;
      if (!updatedFormData.serviceOption) updatedFormData = stampQuoteSubmission(updatedFormData);
      setFinalFormData(JSON.parse(JSON.stringify(updatedFormData)));

      if (updatedFormData.ga4_id) {
        updatedFormData.ga4_id = String(updatedFormData.ga4_id);
      }

      // Submit-funnel telemetry: attempt before the POST, outcome after.
      // Fire-and-forget (sendBeacon); can neither slow nor break the submit.
      telemetryIds.contact_id = updatedFormData.contactId || undefined;
      trackSubmitTelemetry("form_submit_attempt", telemetryIds);
      const submitStartedAt = Date.now();
      const response = await fetch(
        "/api/lead-submit",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedFormData),
        }
      );
      let data;
      try { data = await response.json(); } catch { /* Unreadable replies cannot confirm persistence. */ }
      const confirmed = updatedFormData.serviceOption
        ? data?.success === true && (updatedFormData.autoSubmitted
          ? data.draft_saved === true
          : data.service_option_accepted === true && !!data.deal_id)
        : isConfirmedSubmission(data, updatedFormData);
      if (!response.ok || !confirmed) {
        trackSubmitTelemetry('form_submit_error', { ...telemetryIds, http_status: response.status,
          duration_ms: Date.now() - submitStartedAt });
        telemetryOutcomeSent = true;
        if (!response.ok || data?.status === 'error') {
          sendEmail('Error occured in /api/lead-submit', { request: updatedFormData, error: data });
        }
        const error = new Error(data?.message || 'Your request is still being confirmed. Please retry.');
        error.state = data?.state;
        throw error;
      }
      acceptedResult = data;
      trackSubmitTelemetry('form_submit_success', { ...telemetryIds, http_status: response.status,
        duration_ms: Date.now() - submitStartedAt });
      telemetryOutcomeSent = true;
      if (updatedFormData.autoSubmitted) return acceptedResult;
      if (!updatedFormData.serviceOption) markQuoteSubmissionConfirmed(updatedFormData, data);
      AdsKeys.forEach(item => localStorage.removeItem(item));
      updateDraftRequest({ isSubmitted: true });
      // Prevent auto-submit from firing after successful manual submission
      markQuoteAsSubmitted();

      setPreviousShow(false);
      //setPoolTypeResponse(null);
      //setServiceResponse([]);
      setPoolOptionResponse(null);
      setPoolOption1Response(null);
      return acceptedResult;
    } catch (error) {
      if (!telemetryOutcomeSent) {
        trackSubmitTelemetry("form_submit_error", {
          ...telemetryIds,
          error: String((error && error.message) || error).slice(0, 300),
        });
      }
      console.error("Error:", error);
      if (!dataPayload?.autoSubmitted) {
        setSubmissionError(error.message || 'We could not confirm your request. Please retry.');
        if (!(dataPayload?.serviceOption ? existingQuoteRecovery : confirmationRecovery)) setReviewRequired(true);
      }
      throw error;
    }
  };

  // "Business" on the direct screen: commercial prospects are out of the
  // test's scope, so continue the normal funnel at the commercial branch,
  // exactly as if Slide 2 had been answered "commercial". The assignment id
  // stays on later payloads (splitAssignmentIdForPayload).
  const leaveDirectForCommercial = () => {
    markDirectCommercial();
    setDirectSplit(null);
    trackEvent('split_direct_business_selected', {
      experiment_id: directSplit?.experiment_id || undefined,
      brand: directSplit?.brand || undefined,
    });
    handleNext('commercial', { poolType: 'commercial' });
  };

  // Direct-arm submit: the existing lead-submit payload shape (address from
  // Slide 1, contact fields, attribution) plus the split test fields. Throws
  // on failure so the form can show an error and let the customer retry.
  const submitDirectRequest = async (values) => {
    const assignment = directSplit;
    const payload = stampQuoteSubmission({
      address: formData.address,
      location: formData.location,
      zipCode: formData.zipCode,
      personName: `${values.firstName} ${values.lastName}`.trim(),
      firstName: values.firstName,
      lastName: values.lastName,
      phone: values.phone,
      email: values.email,
      serviceSomethingElse: values.notes,
      poolType: 'residential',
      poolSize: values.poolSize,
      poolCondition: values.poolCondition,
      poolOption: values.poolOption,
      poolOption1: values.poolOption1,
      service: values.service,
      split_plan_interest: values.plans,
      split_assignment_id: assignment.assignment_id || undefined,
      split_direct_request: true,
      formVersion: assignment.brand === 'aqua' || assignment.brand === 'hh' ? 'Direct request' : 'Direct split test',
      quote_variant: 'split_direct',
      quote_experiment_name: '',
      autoSubmitted: false,
      contactId: getContactId(),
      token: 'CABANA-25266-TOKEN',
      site_origin: brandConfig.siteOrigin,
      statsig_user_id: sessionStorage.getItem('statsig_user_id'),
      statsig_stable_id: getStatsigStableId(),
      quote_session: getQuoteSession(),
      ga4_id: String(window.ga4_id || localStorage.getItem('ga4_id') || ''),
      ga_session_id: window.ga_session_id_current || '',
      gpc_signal: Boolean(navigator.globalPrivacyControl || false),
    });
    // Only present when a QA override is active for this session.
    const qaToken = splitQaTokenForPayload();
    if (qaToken) payload.split_qa_token = qaToken;
    AdsKeys.forEach(item => {
      if (localStorage.getItem(item)) payload[item] = localStorage.getItem(item);
    });
    const source = localStorage.getItem('source');
    if (source) { payload.source = source; payload.referrer = source; }
    const landingPage = localStorage.getItem('landing_page');
    if (landingPage) payload.landing_page = landingPage;
    try {
      const fbp = document.cookie.match(/(?:^|;\s*)_fbp=([^;]+)/);
      if (fbp) payload.meta_fbp = decodeURIComponent(fbp[1]);
      const fbc = document.cookie.match(/(?:^|;\s*)_fbc=([^;]+)/);
      if (fbc) payload.meta_fbc = decodeURIComponent(fbc[1]);
      if (navigator.userAgent) payload.client_user_agent = navigator.userAgent;
      const token = window.__cabanaBotDefense?.getTurnstileToken?.();
      if (token) payload.turnstile_token = token;
    } catch (e) { /* best-effort signals; never block the submit */ }

    const telemetryIds = { submit_kind: 'split_direct', contact_id: payload.contactId || undefined };
    trackSubmitTelemetry('form_submit_attempt', telemetryIds);
    const startedAt = Date.now();
    let response;
    try {
      response = await fetch('/api/lead-submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      trackSubmitTelemetry('form_submit_error', { ...telemetryIds, error: String(error?.message || error).slice(0, 300) });
      throw error;
    }
    let result;
    try { result = await response.json(); } catch { /* Require an authoritative receipt. */ }
    if (!response.ok || !isConfirmedSubmission(result, payload)) {
      trackSubmitTelemetry('form_submit_error', { ...telemetryIds, http_status: response.status, duration_ms: Date.now() - startedAt });
      throw new Error(result?.message || 'Your request is still being confirmed. Please retry.');
    }
    trackSubmitTelemetry('form_submit_success', { ...telemetryIds, http_status: response.status, duration_ms: Date.now() - startedAt });
    markQuoteSubmissionConfirmed(payload, result);
    AdsKeys.forEach(item => localStorage.removeItem(item));
    hasCompletedFormRef.current = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'formSubmitted',
      formStep: 'Direct request',
      formData: payload,
      meta_user_data: buildMetaUserData(payload),
      experimentName: assignment.experiment_id || undefined,
      experimentVariant: 'direct',
      sell_deal_id: result?.deal_id ? Number(result.deal_id) : undefined,
      ...getUtmAttribution(),
    });

  };

  const updateDraftRequest = payload => {
    // The direct arm never calls draft-save.
    // Read from storage, not state: the Business choice clears it before
    // React re-renders.
    if (isDirectArmActive()) return;
    try {
      if (!payload) {
        payload = {}
      }
      const poolSizeInput = document.querySelector('input[name="pool_size"]:checked');
      const poolSizeValue = poolSizeInput ? poolSizeInput.value : null;
      const updatedFormData = { ...formData };
      if (updatedFormData.poolType === 'commercial') {
        if (updatedFormData.zipCode) {
          updatedFormData.commercialZipCode = updatedFormData.zipCode;
        }
      }
      if (poolSizeValue) {
        updatedFormData.poolSize = poolSizeValue;
      }
      updatedFormData.contactId = getContactId();
      if (!updatedFormData.contactId) {
        return;
      }
      if (updatedFormData.personName) {
        updatedFormData.personFirstName = updatedFormData.personName?.split(' ')[0]
        updatedFormData.personLastName = updatedFormData.personName?.split(' ')[1]
      }
      if (!updatedFormData.email && payload && payload.email) {
        updatedFormData.email = payload.email;
      }
      if (payload.isSubmitted) {
        updatedFormData.isSubmitted = true
      }
      const splitAssignmentId = splitAssignmentIdForPayload();
      if (splitAssignmentId) updatedFormData.split_assignment_id = splitAssignmentId;
      // /api/draft-save is a no-op that always answers 200, so a failed call
      // loses nothing. Without a catch, every dropped request (offline, a
      // navigation abort, a blocked request) became an unhandled rejection
      // in Sentry (CABANA-QUOTE-FORM-G, 205 events). Keep a breadcrumb so a
      // later real error still shows the network trouble around it.
      fetch(
        "/api/draft-save",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedFormData),
        }
      ).catch(err => {
        Sentry.addBreadcrumb({
          category: 'draft_save',
          level: 'warning',
          message: `draft-save request failed: ${String((err && err.message) || err)}`,
        });
      });
    } catch (error) {

    }
  }

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      if (isButtonClick) {
        swiperRef.current.swiper.on("slideChange", () => {
          var show_namevalue = document.querySelector('#personName');
          var show_name = document.querySelector('#show_name');
          var show_namevalue2 = show_namevalue ? show_namevalue.value : null;
          // Show the #personName value into #show_name
          if (show_name) {
            show_name.innerHTML = show_namevalue2 || "";
          }

          setProgress();
        });
        swiperRef.current.swiper.slideTo(stepIndex);
        setIsButtonClick(false);
      } else if (stepIndex === 0) {
        if (!resumeForm) setSlide1Response(null);
        swiperRef.current.swiper.slideTo(stepIndex);
      } else {
        swiperRef.current.swiper.slideTo(stepIndex);
      }
      // Always run setProgress so the active slide's data-width renders
      // immediately on initial mount too (the slideChange listener only
      // fires on transitions, not on the first paint, which would
      // otherwise leave the bar at 0% on Slide1 until the user advances).
      setProgress();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepIndex, isButtonClick]);

  // When a self-serve sub-state is active, point the Swiper at the sub-state
  // slide (loading, hang-tight, quote review, confirmation). These slides are
  // appended to the Swiper children, so slideTo(stepIndex=12) alone doesn't
  // select them reliably on popstate-driven navigation.
  useEffect(() => {
    if (!swiperRef.current?.swiper) return;
    if (!selfService) return;
    const slides = swiperRef.current.swiper.slides;
    if (slides?.length) {
      swiperRef.current.swiper.slideTo(slides.length - 1);
    }
  }, [selfService]);

  const setProgress = () => {
    setTimeout(() => {
      const bar = document.querySelector('.form-progress-slider');
      if (!bar) return;
      // Per-slide hand-tuned data-width is the primary source: each slide
      // declares the progress bar position the user should see when on it.
      // This stays monotonic across all branches (regular service, regular
      // + equipment, greentoclean, commercial, etc.) because each slide's
      // own width is set in its own component, independent of which other
      // slides happen to be in the Swiper tree.
      const activeSlide = document.querySelector('.swiper-slide-active');
      if (activeSlide) {
        const inputElement = activeSlide.querySelector('#progress_slide_1');
        if (inputElement) {
          const width = inputElement.getAttribute('data-width');
          if (width) {
            bar.style.width = width;
            return;
          }
        }
      }
      // Fallback to a Swiper-count-based estimate if the active slide
      // doesn't declare a width (shouldn't happen in practice).
      const swiper = swiperRef.current?.swiper;
      if (swiper && swiper.slides && swiper.slides.length) {
        const total = swiper.slides.length;
        const current = Math.min(swiper.activeIndex + 1, total);
        bar.style.width = Math.round((current / total) * 100) + '%';
      }
    }, 900)
  }

  // Track step abandonment when user leaves page without completing
  const hasCompletedFormRef = useRef(false);

  // Mark form as completed when user submits (to prevent abandonment tracking)
  useEffect(() => {
    if (selfService === 'success-payment' || selfService === 'service-options-confirmed' || thankYouResponse === 'thankYou') {
      hasCompletedFormRef.current = true;
    }
  }, [selfService, thankYouResponse]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.setItem("redirectFirstStep", "true");

      // Track step abandonment if form not completed and user is past step 1
      if (!hasCompletedFormRef.current && stepIndex > 0) {
        // Determine current step for tracking
        let currentStep = stepIndex + 1;
        let stepName = 'unknown';

        if (selfService === 'loading-analyzing' || selfService === 'hang-tight') {
          stepName = 'loading';
          currentStep = 'loading';
        } else if (selfService === 'cabana-payment') {
          // Don't track abandonment here - auto-submit handles this
          return;
        }

        // Use sendBeacon for reliable tracking during page unload
        const abandonmentData = {
          event: 'step_abandoned',
          step_number: currentStep,
          step_name: stepName,
          variant: showSelfServeForm ? 'treatment' : 'control',
          pool_type: formData.poolType,
          service: formData.service,
          zip_code: formData.zipCode,
          duration: getFormDuration(),
          timestamp: new Date().toISOString(),
        };

        // Push to GTM dataLayer
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'stepAbandoned',
            'formStep': currentStep,
            'stepName': stepName,
            ...abandonmentData
          });
        }
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [stepIndex, selfService, showSelfServeForm, formData]);

  useEffect(() => {
    const shouldRedirect = localStorage.getItem("redirectFirstStep");
    if (window.location.pathname === '/step/13' && sessionStorage.getItem('service_option_offer')) return;
    if (resumeForm) return;
    if (shouldRedirect === "true") {
      localStorage.removeItem("redirectFirstStep");
      window.parent.postMessage(
        {
          type: "step",
          step: 1,
        },
        '*'
      );
      // A beforeunload from the prior quote document can set this flag while a
      // new ad-click entry is loading. Keep only native Google linker inputs
      // through this reset so Conversion Linker can refresh _gcl_aw.
      navigate(quoteEntryTarget(window.location.search), { replace: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Rendered over the form rather than in place of it, so the Swiper keeps its
  // slide position when a retry returns to ordinary intake.
  const restoreScreen = restoringOffer || restoreError ? <section className="tp-root">
    <p role="status">{restoreError
      ? (existingQuoteRecovery ? restoreError : 'We could not confirm your request. Please call us to review it.')
      : 'Restoring your quote...'}</p>
    {restoreError && <>{existingQuoteRecovery && <button onClick={() => serviceOfferRetry.current ? serviceOfferRetry.current() : restoreServiceOffer()}>Retry</button>}
      <p><a href={`tel:${brandConfig.phone.replace(/[^+0-9]/g, '')}`}>Call {brandConfig.phone}</a></p></>}</section> : null;
  const showingServiceOptions = !reviewRequired && !restoreScreen && selfService === 'service-options' && serviceOffer;
  const serviceOptionsConfirmed = !restoreScreen && selfService === 'service-options-confirmed';
  const serviceOptionsPanel = showingServiceOptions ? <TierPicker key={serviceOffer.id} offer={serviceOffer} currentData={finalFormData}
      onVisible={async offer => {
        if (await claimQuoteLane('tier') !== 'tier') throw new Error('Quote session changed');
        await serviceOptionsRequest('expose', { offerId: offer.id });
        const key = `service_option_shown:${offer.id}`;
        if (!sessionStorage.getItem(key)) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'quoteShown', formStep: 'Service options',
            experimentName: 'pricing_tier_test_v1', experimentVariant: offer.arm });
          sessionStorage.setItem(key, 'true');
        }
      }}
      onSelection={selection => {
        sessionStorage.setItem(`service_option_selection:${serviceOffer.id}`, selection.serviceId);
        setFinalFormData(previous => ({
          ...previous, serviceOption: { offerId: serviceOffer.id, ...selection },
        }));
      }}
      onAccept={async selection => {
        const payload = { ...finalFormData, ...selection, autoSubmitted: false, autoSubmitReason: undefined,
          selfServeQuoteAccepted: true, quote_session: getQuoteSession(),
          formVersion: serviceOptionFormVersion(serviceOffer) };
        const unconfirmed = finalFormData;
        let result;
        try {
          result = await fetchData(payload);
        } catch (error) {
          if (error.state === 'existing_quote') { showExistingQuote(); return; }
          if (error.state === 'quote_review_pending') {
            serviceOfferRetry.current = null;
            setSubmissionError('');
            setRestoreError(error.message);
            return;
          }
          throw error;
        } finally {
          // fetchData stores the payload; an unconfirmed request must not leave
          // later autosaves marked as accepted.
          if (!result?.service_option_accepted) setFinalFormData(unconfirmed);
        }
        if (!result?.service_option_accepted) throw new Error('Please retry to confirm your request.');
        setFinalFormData(payload);
        setSelfService('service-options-confirmed');
        window.history.replaceState({ selfService: 'service-options-confirmed' }, '', withPreviewBrand('/step/13'));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'formSubmitted', formStep: 'Service request confirmed',
          experimentName: 'pricing_tier_test_v1', experimentVariant: serviceOffer.arm,
          quoteAmount: payload.amount, formData: payload, meta_user_data: buildMetaUserData(payload),
          sell_deal_id: result?.deal_id ? Number(result.deal_id) : undefined,
          ...getUtmAttribution() });
      }} /> : null;

  const directPanel = !reviewRequired && !restoreScreen && directSplit ? <div className="mini-container"><DirectRequest
      assignment={directSplit}
      address={formData.address || ''}
      initial={{
        firstName: (formData.personName || '').trim().split(/\s+/)[0] || '',
        lastName: (formData.personName || '').trim().split(/\s+/).slice(1).join(' '),
        phone: formData.phone || '',
      }}
      onSubmit={async values => {
        try { await submitDirectRequest(values); }
        catch (error) {
          if (!confirmationRecovery) { setSubmissionError(error.message); setReviewRequired(true); }
          throw error;
        }
      }}
      onBusiness={leaveDirectForCommercial} /></div> : null;

  return <>
    {submitting && confirmationRecovery && <p role="status">Saving your request…</p>}
    {submissionError && <div className="mini-container" role="alert">{reviewRequired
      ? 'We could not confirm your request. Please call us to review it.' : submissionError}</div>}
    {restoreScreen}
    {(selfService === 'existing-quote' || reviewRequired) && <section className="tp-root">
      <h1>Please contact us to review your request</h1>
      <p>{existingQuoteRecovery
        ? 'We need to review your existing request before confirming a service or making changes. Please call us for help.'
        : 'Please call us for help with your request.'}</p>
      <a href={`tel:${brandConfig.phone.replace(/[^+\d]/g, '')}`}>{brandConfig.phone}</a>
    </section>}
    {directPanel}
    {serviceOptionsPanel}
    {serviceOptionsConfirmed && <section className="tp-root"><h1>We received your service request</h1>
      <p>We will contact you to confirm the details and start date.</p></section>}
    <div className="mini-container" hidden={reviewRequired || !!restoreScreen || !!showingServiceOptions || serviceOptionsConfirmed || selfService === 'existing-quote' || !!directPanel}>
      <div className="swiper-container">
        <Swiper
          modules={[Navigation, EffectFade]}
          navigation={{
            prevEl: ".swiper-button-prev",
          }}
          ref={swiperRef}
          spaceBetween={50}
          slidesPerView={1}
          noSwiping={true}
          noSwipingClass="swiper-no-swiping"
          simulateTouch={false}
          touchRatio={0}
          shortSwipes={false}
          longSwipes={false}
          effect="fade"
          fadeEffect={{
            crossFade: true,
          }}
          speed={800}
        >
          <SwiperSlide data-resume-slide="contact">
            <Slide1 initialData={resumeForm || {}} onNext={handleNext} />
            {/* <Slide13 getPoolUrl={handlePoolURL} onNext={handleNext} poolSize={formData.poolSize} zipCode={zipCode} manualText={manualText} poolTypeResponse={poolTypeResponse} /> */}
            {/* <QuoteReview onNext={handleNext} currentData={finalFormData} zipCode={zipCode} /> */}
            {/* <SlideOutOfService personName={formData.personName} onNext={handleNext} onBack={handlePrev} /> */}
            {/* <LoadingAnalyzing onNext={handleNext} poolURL={formData.poolURL} /> */}
            {/* <HangTight onNext={handleNext} /> */}
            {/* <QuoteConfirmation currentData={finalFormData} onNext={handleNext} /> */}
            {/* <Slide5 onNext={handleNext} onBack={handlePrev} onCommercialClick={handleCommercialClick} /> */}
          </SwiperSlide>
          {!slide1Response && (
            <>
              <SwiperSlide>
                <Slide2 onNext={handleNext} onBack={handlePrev} />
              </SwiperSlide>
              <SwiperSlide>
                <Slide21 onNext={handleNext} onBack={handlePrev} />
              </SwiperSlide>
            </>
          )}
          <SwiperSlide data-resume-slide="type">
            <Slide3 initialData={resumeForm || {}} onNext={handleNext} onBack={handlePrev} />
          </SwiperSlide>
          {poolTypeResponse === "commercial" && (
            <SwiperSlide>
              <Slide4 onNext={handleNext} onBack={handlePrev} onResidentialClick={handleResidentialClick} />
            </SwiperSlide>
          )}
          {poolTypeResponse === "residential" && (
            <SwiperSlide data-resume-slide="service">
              <Slide5 initialData={resumeForm || {}} onNext={handleNext} onBack={handlePrev} onCommercialClick={handleCommercialClick} />
            </SwiperSlide>
          )}
          {poolTypeResponse === "residential" &&
            serviceResponse?.includes("regular_pool_spa_service") && (
              <SwiperSlide data-resume-slide="condition">
                <SlidePoolCondition
                  onNext={handleNext}
                  onBack={handlePrev}
                  formData={formData}
                  zipCode={zipCode}
                />
              </SwiperSlide>
            )}
          {poolTypeResponse === "residential" &&
            serviceResponse?.includes("equipment_repair") && (
              <SwiperSlide data-resume-slide="equipment">
                <Slide7 initialData={resumeForm || {}} onNext={handleNext} onBack={handlePrev} />
              </SwiperSlide>
            )}
          {poolTypeResponse === "residential" &&
            serviceResponse?.includes("greentoclean") && (
              <SwiperSlide data-resume-slide="g2c-contact">
                <Slide6 initialData={resumeForm || {}} onNext={handleNext} onBack={handlePrev} />
              </SwiperSlide>
            )}
          {poolTypeResponse === "residential" &&
            !serviceResponse?.includes("greentoclean") && (
              <SwiperSlide data-resume-slide="features">
                <Slide8 initialData={resumeForm || {}} onNext={handleNext} onBack={handlePrev} />
              </SwiperSlide>
            )}
          {poolTypeResponse === "residential" &&
            !serviceResponse?.includes("greentoclean") &&
            (poolOptionResponse === 'something_else' || poolOptionResponse === "pool_only" ||
              poolOptionResponse === "pool_spa" || poolOptionResponse === "pool_hot_tub") && (
              <SwiperSlide data-resume-slide="environment">
                <Slide9 initialData={resumeForm || {}} onNext={handleNext} onBack={handlePrev} />
              </SwiperSlide>
            )}
          {poolTypeResponse === "residential" &&
            !serviceResponse?.includes("greentoclean") &&
            (formData.poolOption1?.includes('ground_pool')) && (
              <SwiperSlide data-resume-slide="above-ground-contact">
                <Slide10 initialData={resumeForm || {}} onNext={handleNext} onBack={handlePrev} />
              </SwiperSlide>
            )}
          {poolTypeResponse === "residential" &&
            !serviceResponse?.includes("greentoclean") &&
            !formData.poolOption1?.includes('ground_pool') &&
            (poolOptionResponse === 'something_else' || poolOptionResponse === "pool_only" ||
              poolOptionResponse === "pool_spa" || poolOptionResponse === "pool_hot_tub") && (
              <SwiperSlide data-resume-slide="size">
                <Slide11 initialData={resumeForm || {}} onNext={handleNext} onBack={handlePrev} />
              </SwiperSlide>
            )}
          {poolTypeResponse === "residential" &&
            !serviceResponse?.includes("greentoclean") && !formData.poolOption1?.includes('ground_pool') && (
              <SwiperSlide data-resume-slide="final-contact">
                <Slide12 initialData={resumeForm || {}} onNext={handleNext} onBack={handlePrev} />
              </SwiperSlide>
            )}
          {poolTypeResponse && poolTypeResponse === "out-of-service" && (
            <SwiperSlide>
              <SlideOutOfService personName={formData.personName} onNext={handleNext} onBack={handlePrev} />
            </SwiperSlide>
          )}
          {poolTypeResponse && poolTypeResponse !== "out-of-service" && (
            <SwiperSlide>
              <Slide13 getPoolUrl={handlePoolURL} onNext={handleNext} poolSize={formData.poolSize} zipCode={zipCode} manualText={manualText} poolTypeResponse={poolTypeResponse} />
            </SwiperSlide>
          )}
          {
            selfService === 'loading-analyzing' && <SwiperSlide>
              <LoadingAnalyzing onNext={handleNext} zipCode={zipCode} poolURL={formData.poolURL} />
            </SwiperSlide>
          }
          {
            selfService === 'hang-tight' && <SwiperSlide>
              <HangTight onNext={handleNext} />
            </SwiperSlide>
          }
          {
            selfService === 'cabana-payment' && <SwiperSlide>
              <QuoteReview onNext={handleNext} currentData={finalFormData} poolURL={formData.poolURL} zipCode={zipCode} />
            </SwiperSlide>
          }
          {
            selfService === 'success-payment' && <SwiperSlide>
              <QuoteConfirmation currentData={finalFormData} onNext={handleNext} />
            </SwiperSlide>
          }
          {previousShow && stepIndex > 0 && selfService !== 'success-payment' && (
            <div className="swiper-button-prev" onClick={handlePrev}></div>
          )}
        </Swiper>
      </div>
    </div>
  </>;
};

export default Step;
